import { Component, inject, signal } from '@angular/core';
import {
  AppointmentsClient,
  AppointmentStatsForAdminResponse,
  AppointmentStatsPeriod,
} from '../../../infrastructure/shared/model/fss.api';
import { firstValueFrom } from 'rxjs';
import { AdminAppointmentsTable } from '../admin-appointments-table/admin-appointments-table';
import { AdminAppointmentsCalendar } from '../admin-appointments-calendar/admin-appointments-calendar';
import { PageComponent } from '../../../infrastructure/shared/components/page/page';
import { Tab, TabList, Tabs } from 'primeng/tabs';
import { List } from '../../../infrastructure/shared/icons/list/list';
import { Calendar } from '../../../infrastructure/shared/icons/calendar/calendar';
import { CheckCircle } from '../../../infrastructure/shared/icons/check-circle/check-circle';
import { Percent03 } from '../../../infrastructure/shared/icons/percent-03/percent-03';
import { formatNumberPlain } from '../../../infrastructure/shared/functions/functions';

type ViewMode = 'list' | 'calendar';

@Component({
  standalone: true,
  selector: 'app-admin-appointments-page',
  imports: [
    AdminAppointmentsTable,
    AdminAppointmentsCalendar,
    PageComponent,
    Tabs,
    TabList,
    Tab,
    List,
    Calendar,
    CheckCircle,
    Percent03,
  ],
  templateUrl: './admin-appointments-page.html',
  styleUrl: './admin-appointments-page.scss',
})
export class AdminAppointmentsPage {
  client = inject(AppointmentsClient);

  /** Props */
  statsOptionSelected: AppointmentStatsPeriod = AppointmentStatsPeriod.WEEK;
  stats = signal<AppointmentStatsForAdminResponse | undefined>(undefined);
  viewMode = signal<ViewMode>('list');

  constructor() {
    this.load();
  }

  load() {
    this._getStats().then((res) => {
      this.stats.set(res.result);
    });
  }

  onPeriodChange(period: string | number | undefined) {
    this.statsOptionSelected = period as AppointmentStatsPeriod;
    this.load();
  }

  onViewModeChange(value: string | number | undefined) {
    this.viewMode.set(value === 'calendar' ? 'calendar' : 'list');
  }

  private async _getStats() {
    return await firstValueFrom(this.client.getAppointmentStatsForAdmin(this.statsOptionSelected));
  }

  protected readonly AppointmentStatsPeriod = AppointmentStatsPeriod;
  protected readonly formatNumber = formatNumberPlain;
}
